import React from 'react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  const gridItems = [{
    title: 'Noche (10 min)',
    subtitle: 'Preparación',
    items: ['Temperatura', 'Mente', 'Hábitos']
  }, {
    title: 'Despertar (3 min)',
    subtitle: 'El momento crítico',
    items: ['Acción Inmediata', 'Sin Negociación', 'Reset Físico']
  }, {
    title: 'Mañana (10 min)',
    subtitle: 'Cierre del ciclo',
    items: ['Luz', 'Movimiento', 'Registro']
  }];
  return <section className="w-full bg-[#1B2838] py-24 px-6 overflow-hidden relative" data-id="element-94">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#E8614D]/5 to-transparent pointer-events-none" data-id="element-95" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-97">
          <h2 className="text-3xl md:text-5xl font-bold text-[#F5E6D0] mb-6 font-sans" data-id="element-98">
            Presento: 3:00 AM Reset{' '}
            <span className="text-[#E8614D] text-2xl align-top" data-id="element-99">
              (Kit Express)
            </span>
          </h2>
          <p className="text-xl text-[#B8A99A] max-w-2xl mx-auto font-serif" data-id="element-100">
            Un PDF práctico hecho para el problema más específico: despertarte a
            las 3–4am y no poder volver a conciliar.
          </p>
        </motion.div>

        <div className="mb-12 text-center" data-id="element-101">
          <span className="inline-block py-1 px-3 rounded-full bg-[#E8614D]/10 text-[#E8614D] text-sm font-bold tracking-wider uppercase mb-4" data-id="element-102">
            El Mecanismo
          </span>
          <h3 className="text-3xl font-bold text-[#F5E6D0] font-sans" data-id="element-103">
            Doble-Ruta 3×3
          </h3>
        </div>

        {/* The 3x3 Grid Visualization */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-104">
          {gridItems.map((col, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2,
          duration: 0.6
        }} className="bg-[#0F1923] rounded-xl overflow-hidden border border-[#B8A99A]/10 hover:border-[#E8614D]/30 transition-colors duration-300" data-id="element-105">
              <div className="bg-[#15202B] p-6 border-b border-[#B8A99A]/5" data-id="element-106">
                <h4 className="text-[#E8614D] font-bold text-lg mb-1" data-id="element-107">
                  {col.title}
                </h4>
                <p className="text-[#B8A99A] text-sm" data-id="element-108">{col.subtitle}</p>
              </div>
              <div className="p-6 space-y-4" data-id="element-109">
                {col.items.map((item, j) => <div key={j} className="flex items-center gap-3" data-id="element-110">
                    <div className="w-8 h-8 rounded-full bg-[#1B2838] flex items-center justify-center text-[#F5E6D0] text-xs font-bold border border-[#B8A99A]/20" data-id="element-111">
                      {j + 1}
                    </div>
                    <span className="text-[#F5E6D0] font-medium" data-id="element-112">{item}</span>
                  </div>)}
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8,
        duration: 0.8
      }} className="mt-12 text-center" data-id="element-113">
          <p className="text-[#F5E6D0] text-xl font-medium" data-id="element-114">
            Resultado: no adivinas.{' '}
            <span className="text-[#E8614D] font-bold" data-id="element-115">
              Identificas la ruta y ejecutas.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}